import { useEffect, useRef, useState } from "react";

//ASSETS
import LeftArrow from "assets/icons/ArrowLeftHovered.svg";
import RedLoop from "assets/svg/SearchIconRed.svg";
import CoverPlaceholder from "assets/img/CoverPlaceholder.png";
import { ReactComponent as NoDataDark } from "assets/svg/NoDataDark.svg";

// STYLES
import {
  BackToGuidesButton,
  BackToGuidesImage,
  BackToGuidesWrapper,
  CardContainer,
  ImgStyled,
  InputContainer,
  NoDataContainer,
  OfficialAnnouncementsContainer,
  SvgContainer,
  TitleWrapper,
  Wrapper,
} from "./NewsAndPartnersStyled";

// LIBRARIES
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";

// MISC
import { ButtonType } from "components/Atoms/ButtonAtom/ButtonAtomModel";
import { TextType } from "components/Atoms/CustomText/CustomTextModel";
import { OptionType } from "components/Atoms/InputAtom/InputAtomModel";
import { appRoutes } from "config/AppRoutesConfig";
import { COLORS } from "constants/variables";
import { uploadBaseUrl } from "services/base";

// COMPONENTS
import ButtonAtom from "components/Atoms/ButtonAtom/ButtonAtom";
import CustomText from "components/Atoms/CustomText/CustomText";
import InputAtom from "components/Atoms/InputAtom/InputAtom";
import Pagination from "components/Atoms/Paginations/Pagination";
import NewsCard from "components/NewsCard/NewsCard";

// REDUX
import { useSelector } from "react-redux";
import newsAndMediaService from "services/newsAndMediaService";
import { accessibilityBiggerCursorSelector } from "slices/UISlice/uiSliceSelectors";
import { ArticleTitleWrapper } from "components/ArticlesSection/ArticlesSectionStyled";

// CONFIGURATION

const OfficialAnnouncements = () => {
  // PROPERTIES

  // API REQUESTS

  // The tabs for the menu

  // Function to handle tab selection

  // LIBRARY CONSTANTS
  const topRef = useRef(null);
  const { t } = useTranslation();
  const navigate = useNavigate();
  const biggerCursor = useSelector(accessibilityBiggerCursorSelector);

  // STATE CONSTANTS

  const [inputText, setInputText] = useState<string>("");
  const [options, setOptions] = useState<OptionType[]>([]);
  const [currentPage, setCurrentPage] = useState<number>(1);
  //eslint-disable-next-line
  const [totalPages, setTotalPages] = useState<number>(10);
  const [articles, setArticles] = useState<any>();
  const pageSize = 6;

  // LIFE CYCLE
  useEffect(() => {
    newsAndMediaService
      .getNewsArticlesByCategory(currentPage, pageSize, inputText, 2)
      .then((data) => {
        // console.log("getNewsArticlesByCategory", data);
        const sortedArticles = data?.data?.slice().sort((a, b) => {
          const dateA = new Date(
            a.attributes.article_date || a.attributes.publishedAt
          ).getTime();
          const dateB = new Date(
            b.attributes.article_date || b.attributes.publishedAt
          ).getTime();
          return dateB - dateA;
        });
        setArticles({ ...data, data: sortedArticles });
        setTotalPages(data?.meta?.pagination?.pageCount);
      })
      .catch((err) => {
        console.error(err);
      });
  }, [currentPage, pageSize, inputText]);

  // EVENT HANDLERS

  const handlePageChange = (page: number) => {
    setCurrentPage(page);
    topRef.current.scrollIntoView({
      behavior: "smooth",
      block: "start",
    });
  };

  return (
    <OfficialAnnouncementsContainer ref={topRef}>
      <BackToGuidesWrapper
        onClick={() => navigate(appRoutes.news)}
        biggerCursor={biggerCursor}
      >
        <BackToGuidesImage src={LeftArrow} alt="backIcon" />
        <BackToGuidesButton biggerCursor={biggerCursor}>
          <CustomText
            text={t("view.newsAndMedia.officialAnnouncements.backButton")}
            type={TextType.H5boldspaced}
            color={COLORS.RaisinBlack}
          />
        </BackToGuidesButton>
      </BackToGuidesWrapper>
      <TitleWrapper>
        <CustomText
          text={t("view.newsAndMedia.ParnersNews")}
          type={TextType.H2}
        />
      </TitleWrapper>
      <InputContainer>
        <form
          onSubmit={(event) => {
            event.preventDefault();
            // if (inputText !== "") {
            //   setOptions([{ option: "0 rezultate", id: 0, path: `/` }]);
            // }
          }}
        >
          <InputAtom
            startAdornment={<ImgStyled src={RedLoop} alt="RedLoopIcon" />}
            endAdornment={
              <ButtonAtom
                text={t("view.newsAndMedia.officialAnnouncements.search")}
                type={ButtonType.ArrowDownDefault}
              />
            }
            placeholder={t(
              "view.newsAndMedia.officialAnnouncements.searchPlaceholder"
            )}
            isSearchBar={true}
            options={options}
            onChange={(e) => setInputText(e.target.value)}
            isModal={true}
          />
        </form>
      </InputContainer>
      {articles?.data.length > 0 ? (
        <>
          <Wrapper>
            <CardContainer>
              {articles?.data.map((card) => {
                return (
                  <NewsCard
                    id={card?.id}
                    img={
                      card?.attributes?.cover?.data?.attributes?.url?.trim()
                        ? `${uploadBaseUrl}${card?.attributes?.cover?.data?.attributes?.url}`
                        : CoverPlaceholder
                    }
                    title={card?.attributes?.title}
                    timeToRead={card?.attributes?.reading_time || ""}
                    partner={
                      card?.attributes?.partener?.data?.attributes?.title || ""
                    }
                    timeline={
                      card?.attributes?.article_date
                        ? card?.attributes?.article_date
                        : card?.attributes?.createdAt
                    }
                    route={appRoutes.newsAndPartnersDetails}
                  />
                );
              })}
            </CardContainer>
          </Wrapper>
          {totalPages > 1 && (
            <Pagination
              totalPages={totalPages}
              currentPage={currentPage}
              onPageChange={handlePageChange}
            />
          )}
        </>
      ) : (
        <NoDataContainer>
          <SvgContainer>
            <NoDataDark />
          </SvgContainer>
          <ArticleTitleWrapper>
            <CustomText
              text={t("app.noData")}
              type={TextType.H4}
              color={COLORS.ChineseSilver}
            />
          </ArticleTitleWrapper>
        </NoDataContainer>
      )}
    </OfficialAnnouncementsContainer>
  );
};

export default OfficialAnnouncements;
